<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="row row-padding justify-content-center">
        <div class="col-auto">
          <label class="fs-32">Forgot your password?</label>
        </div>
      </div>
      @if (!isPasswordRequestSent) {
        <div class="row row-padding justify-content-center">
          <div class="col-auto">
            <label
              >Forgot your password? Please enter your e-mail address below and
              a password reset link will be sent to you.</label
            >
          </div>
        </div>
      }
      @if (!isPasswordRequestSent) {
        <div class="row row-padding justify-content-center">
          <div class="col-4">
            <input
              class="form-control"
              [(ngModel)]="Entry.email"
              [pattern]="EmailRegex.source"
            />
          </div>
        </div>
      }
      @if (!isPasswordRequestSent) {
        <div class="row row-padding justify-content-center">
          <div class="col-auto">
            <button
              class="btn btn-primary"
              (click)="sendPasswordResetRequest()"
            >
              Send password reset link
            </button>
          </div>
        </div>
      }
      @if (isPasswordRequestSent) {
        <div class="row row-padding justify-content-center">
          <div class="col-auto">
            <label
              >An e-mail has been sent to you with instructions on how to reset
              your password. Click the link located in the e-mail sent to you to
              continue.</label
            >
          </div>
        </div>
      }
      @if (isPasswordRequestSent) {
        <div class="row row-padding justify-content-center">
          <div class="col-auto">
            <label
              >If you need additional assistance, or if you run into an error
              when resetting your password, please contact our customer service
              department at
              <a href="tel:+18444768038">1 (844) 476-8038</a></label
            >
          </div>
        </div>
      }
    </div>
  </div>
</div>
